"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var types = __importStar(require("@babel/types"));
var utils_1 = require("../utils");
function parseDirectives(_a) {
    var attrs = _a.attrs, attr = _a.attr;
    if (types.isArrayExpression(attr.value)) {
        attr.value.elements.forEach(function (v) {
            if (!types.isObjectExpression(v))
                return;
            var key = v.properties.find(function (v) {
                if (!types.isObjectProperty(v))
                    return;
                return v.key.name == "rawName";
            });
            var value = v.properties.find(function (v) {
                if (!types.isObjectProperty(v))
                    return;
                return v.key.name == "expression";
            });
            if (!key)
                return;
            if (!types.isObjectProperty(key))
                return;
            //@ts-ignore
            attrs.push(types.jsxAttribute(
            //@ts-ignore
            types.jsxIdentifier(utils_1.getCamelCase.apply(void 0, (key.value.value || key.value.name).replace(/\./, "_").split("-"))), value ? types.jsxExpressionContainer(value.value) : null));
        });
    }
}
exports.parseDirectives = parseDirectives;
//# sourceMappingURL=directives.js.map